import { FiUpload } from "react-icons/fi";
import { GiCommercialAirplane } from "react-icons/gi";
import { BsFillMicFill } from "react-icons/bs";

const RecentActivityData = [
  {
    id: 1,
    color: "info",
    title: "You Sold an Item",
    msg: "Paul Burgess purchased an item",
    time: "5 min ago",
    icon: <FiUpload />,
  },
  {
    id: 2,
    color: "primary",
    title: "Product on the Bootstrap Market",
    msg: "Dave Gamache added Admin Dashboard",
    time: "30 minutes ago",
    icon: <GiCommercialAirplane />,
  },
  {
    id: 3,
    color: "info",
    title: "Robert Delaney",
    msg: `Send you message "Are you there?"`,
    time: "2 hours ago",
    icon: <BsFillMicFill />,
  },
  {
    id: 4,
    color: "primary",
    title: "Audrey Tobey",
    msg: `Uploaded a photo "Error.jpg"`,
    time: "14 hours ago",
    icon: <FiUpload />,
  },
  {
    id: 5,
    color: "info",
    title: "Product on the Bootstrap Market",
    msg: "Dave Gamache added Admin Dashboard",
    time: "22 hours ago",
    icon: <GiCommercialAirplane />,
  },
  {
    id: 6,
    color: "primary",
    title: "Robert Delaney",
    msg: `Send you message "Are you there?"`,
    time: "2 days ago",
    icon: <BsFillMicFill />,
  },
  {
    id: 7,
    color: "info",
    title: "You Sold an Item",
    msg: "Paul Burgess purchased an item",
    time: "2 days ago",
    icon: <FiUpload />,
  },
  {
    id: 8,
    color: "primary",
    title: "Product on the Bootstrap Market",
    msg: "Dave Gamache added Admin Dashboard",
    time: "2 days ago",
    icon: <GiCommercialAirplane />,
  },
];
export default RecentActivityData;
// module.exports = RecentActivityData;
